module.exports = __webpack_public_path__ + "static/media/social-google.24e11f98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-google.svg
// module id = 120
// module chunks = 0